import { Suspense } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { MobileNavigation } from '@/app/layouts/app-layout/MobileNavigation';
import { env } from '@/shared/config';
import { PageLoader } from '@/shared/ui';
import { DesktopSidebar } from '@/components/base/desktop/desktopHeader/DesktopSidebar';
import { useAuthStore } from '@/store/auth';

/**
 * Лэйаут раздела «Планирование»: реальный сайдбар проекта + контент во всю
 * доступную ширину (без `container`-ограничения AppLayout, из-за которого по
 * бокам оставался «воздух»). Свой топ-бар у страницы есть, поэтому глобальный
 * Header не рендерим.
 *
 * Suspense вокруг `Outlet` — по той же причине, что и в FullWidthLayoutRoute:
 * иначе ленивый чанк страницы гасит весь экран вместе с сайдбаром.
 */
export function PlanningLayoutRoute() {
  const isAuthenticated = useAuthStore(
    (state) => env.authBypass || state.isAuthenticated
  );
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <div className="flex min-h-screen bg-background">
      <DesktopSidebar />
      <div className="h-screen min-w-0 flex-1 overflow-y-auto overflow-x-hidden">
        <Suspense fallback={<PageLoader className="h-full" />}>
          <Outlet />
        </Suspense>
      </div>
      <MobileNavigation />
    </div>
  );
}
